import { render } from "./UserProjects.vue?vue&type=template&id=08b08c60"
import script from "./UserProjects.vue?vue&type=script&lang=js"
export * from "./UserProjects.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3192575638/src/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__